﻿import { request_trip_passenger } from "./request_trip_passenger";

export class request_trip {
    public booking_identifier: string | null = null;
    public passengers: request_trip_passenger[] = [];
}